import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/documents`;

export interface GetClaimDocumentsPayload {
  claimId: string;
}

export const getClaimDocumentsRequest = ({
  claimId,
}: GetClaimDocumentsPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId),
  config: { method: SUPPORTED_METHODS.GET, timeout: 30000 },
});

export interface Document {
  extension: string;
  id: string;
  name: string;
  originalFileName: string;
  url: string;
}

export interface DocumentValues {
  documents: Document[];
}

export interface GetClaimDocumentsResponse extends BaseBackResponse {
  value: DocumentValues;
}

async function getClaimDocuments({
  claimId,
}: GetClaimDocumentsPayload): Promise<DocumentValues> {
  const functionName = 'getClaimDocuments';

  if (!claimId) {
    throw new RequiredPayloadFieldIsNotProvided(claimId, `${functionName}`);
  }

  const response = await executeQuery<GetClaimDocumentsResponse>(
    getClaimDocumentsRequest({ claimId }),
  );

  return response.value;
}

export default getClaimDocuments;
